import { api, type Job } from "../../shared/api.ts";

export const JOB_UPDATED = "ic:job-updated";

/** Share the server's actual result with both the header list and the estimate page. */
export async function cancelEstimate(id: string): Promise<Job> {
  const job = await api.jobCancel(id);
  window.dispatchEvent(new CustomEvent<Job>(JOB_UPDATED, { detail: job }));
  return job;
}
